import React 					from 'react';
import PropTypes 				from 'prop-types';
import BLComponent 				from '../core/_BLComponent.jsx';

import FloatingImage 			from '../common/_FloatingImage.jsx';
import ControlledNumberInput 	from '../common/_ControlledNumberInput.jsx';
import SellerStoreLockup 		from '../common/_SellerStoreLockup.jsx';
import MultilineHiddenText 		from '../common/_MultilineHiddenText.jsx';
import {ClickShowTooltip}		from '../common/_Utilities.jsx';

export default class SellerBox extends BLComponent 
{
	constructor( props, context ) 
	{
		super( props, context );

		this.state = {
		}

		this.isAdmin = true;
	}

	render() 
	{
		const {classes = ''} = this.props;
		
		return (
			<article className={"pdp-user-selection pdp__side-group " + classes}>
				{this.renderUserSelectionArea()}
				{this.renderStoreArea()}
				{this.renderStoreAreaExtra()}
			</article>
		);
	}

	renderUserSelectionArea() 
	{
		const 	wantedQty 	= this.props.wantedQty;
		let		condItems	= [];

		if ( this.props.typeItem == "S" )
		{
			condItems	=	[
								<option key="NS" value="NS">{$T("NEW_SEALED")}</option>
							,	<option key="NC" value="NC">{$T("NEW_COMPLETE")}</option>
							,	<option key="UC" value="UC">{$T("USED_COMPLETE")}</option>			
							];
		}
		else
		{
			condItems	=	[
								<option key="N" value="N">{$T("NEW")}</option>
							,	<option key="U" value="U">{$T("USED")}</option>			
							];
		}

		return (
			<section className="l-margin-bottom pdp-user-selection__modify">
				<div className="pdp-user-selection__item">
					<strong className="pdp-user-selection__label">{$T("QUANTITY")}</strong>
					<ControlledNumberInput value={this.props.selectedQty} onChangeFunc={(value) => this.props.func.updateQty(value)}/>
					{wantedQty ? <small className="l-block text--note l-margin-top--xs">{$T("MY_WANTED_QTY")} {wantedQty}</small> : null}
				</div>
				<div className="pdp-user-selection__item">
					<strong className="pdp-user-selection__label">{$T("CONDITION")}<i className="fas fa-info-circle l-margin-left--sm js-bottom-right-tooltip" data-tooltip={$T("ONLY_COMPLETE_SETS")} data-tooltip-width={126} onClick={(e) => ClickShowTooltip(e)}/></strong>
					<select className="select l-full-width" value={this.props.selectedCond} onChange={(e)=>this.props.func.updateCond(e.target.value)}>
						{condItems}
					</select>
				</div>
			</section>
		);
	}

	renderStoreArea() 
	{
		switch ( this.props.status ) 
		{
		case 0:		return this.renderLoading();
		case 1:		return this.renderStoreFound();
		case 2:		return this.renderLegoOnly();
		case 3:		return this.renderNoInstantCheckout();
		case 4:		return this.renderNoAvailable();
		case -1:	return this.renderError();
		default:	return;
		}
	}

	renderStoreAreaExtra() 
	{
		if ( this.props.status == 1 && this.props.chosenInvData != null )
		{
			if ( this.props.chosenInvData.nMatchingInvQty >= this.props.selectedQty )
				return;
			if ( this.props.maxBuyableQty >= this.props.selectedQty )
				return this.renderEasyBuyAll();
			return this.renderEasyBuySome();
		}		
	}

	renderLoading()
	{
		return (
			<section className=" text--center">
				{$T("LOADING")}
			</section>
		)
	}

	renderError()
	{
		return (
			<section className=" text--center">
				{$T("ERROR")}
			</section>
		)
	}

	renderStoreFound() 
	{
		const	data					= this.props.chosenInvData;
		const	store					= data.dmStore;
		let		invs					= [];
		let		totalQty				= 0;
		let		qtyInCart				= 0;

		_.forEach( 
			data.mapInvs
		,	( inv ) => 
			{ 
				invs.push( inv ); 
				totalQty 	+= inv.nBuyQty; 
				qtyInCart	+= inv.nQtyInCart;
			} 
		);

		invs.sort( ( l, r ) => r.nBuyQty - l.nBuyQty );

		const	inv						= invs[ 0 ];
		const	sellerNote 				= inv ? inv.dmInv.strDesc : '';
		const	sellerImage 			= inv ? blapp.url2.getInvImgUrl( inv.dmInv ) : '';
		const	sellerNoteExtended		= inv ? inv.strExtendedDesc : '';
		const	mTotalPriceInDispCur	= data.mTotalItemNetPriceInDisplayCurrency;
		const	mTotalPriceInStoreCur	= data.mTotalItemNetPriceInStoreCurrency;
		const	singlePriceInDispCur 	= data.mTotalItemNetPriceInDisplayCurrency / Math.max( totalQty, 1 );
		const	singlePriceInStoreCur 	= data.mTotalItemNetPriceInStoreCurrency / Math.max( totalQty, 1 );

		const	lotsInCart 	= data.nLotsInCart;
		const	coupon 		= data.nCouponCnt > 0;
		const	st			= blapp.country.getStateLegacy( store.idState );
		const	country		= blapp.country.get( store.codeCountry );
		const	location 	= country ? ( ( ( st && !_.isEmpty( st.strStateName ) ) ? st.strStateName + ", " : "" ) + country.strCountryName ) : ""
		const	favorite	= data.isFavorite;

		const sellerTerms = data.storeTerms && data.storeTerms.storeTerms ? data.storeTerms.storeTerms : null;
		let sellerTermsTrimmed = sellerTerms && `${sellerTerms.replace(/(<([^>]+)>)/ig,"").substring(0, 100)}${sellerTerms.length > 100 ? '...' : ''}`;
		sellerTermsTrimmed = blapp.util.decodeHtml(sellerTermsTrimmed);
		return (
			<section className="pdp-user-selection__store">
				<div className="l-margin-bottom--xl">
					<SellerStoreLockup classes="store-detail-lockup--large" details={{storeName: store.strStoreName, flag: store.codeCountry, feedbackScore: store.nFeedbackScore, favorite: favorite }}/>
					<p className="text--note l-margin-top--sm">{location}</p>
					{lotsInCart > 0 ? <p className="text--note">{lotsInCart} lot{lotsInCart != 1 && 's'} in cart</p> : null}
					{coupon && <p className="text--small l-margin-top--xxs"><i className="far fa-tag fa-flip-horizontal l-margin-right--sm"/>Coupon available</p>}
				</div>
				<div className="l-flex l-split l-margin-bottom--xl">
					<div className="l-margin-right--sm">
						<div><strong className="text--small-title">{blapp.format.formatMoney(singlePriceInDispCur, blapp.session.idCurrencyDetected)}</strong> x{totalQty}</div>
						{(store.idStoreCurrency != blapp.session.idCurrencyDetected) && <small className="l-block">({blapp.format.formatMoney(mTotalPriceInStoreCur, store.idStoreCurrency)})</small>}
					</div>
					<div className="l-margin-left--sm text--right">
						<strong className="text--small-title l-block">{blapp.format.formatMoney(mTotalPriceInDispCur, blapp.session.idCurrencyDetected)}</strong>
						{(store.idStoreCurrency != blapp.session.idCurrencyDetected) && <small className="l-block">({blapp.format.formatMoney(singlePriceInStoreCur, store.idStoreCurrency)})</small>}
						{store.mMinBuy != 0 && <small className="l-block">Min. buy: {blapp.format.formatMoney(store.mMinBuy, store.idStoreCurrency)}</small>}
					</div>
				</div>
				<button className="btn btn--cta-alt text--bold l-full-width" onClick={(e) => this.props.func.doAddToCart()}>{$T("ADD_N_TO_CART", [totalQty])}</button>
				{sellerNote || sellerImage ?
					<div className="pdp-user-selection__note">
						<h3 className="text--small-title text--bold l-margin-bottom">{$T("NOTE_FROM_SELLER")}</h3>
						{sellerNote && <div className="l-margin-bottom--sm">{blapp.util.stripHtml(sellerNote)}</div>}
						{sellerNote && <button className="btn btn--link" onClick={() => this.props.func.toggleSellerNotesModal()}>Read more</button>}
						{sellerImage &&
							<figure className="l-margin-top" onClick={() => this.props.func.toggleSellerNotesModal()}>
								<FloatingImage><img src={sellerImage}/></FloatingImage>
							</figure>
						}
					</div>
				: null}
				{sellerTerms ? 
					<div className="pdp-user-selection__note">
						<h3 className="text--small-title text--bold l-margin-bottom">{$T("STORE_TERMS")}</h3>
						<div className="l-margin-bottom">{sellerTermsTrimmed}</div>
						<button className="btn btn--link" onClick={() => this.props.func.toggleSellerTermsModal()}>Read more about terms and policies</button>
					</div>
				: null}
			</section>
		);
	}

	renderLegoOnly() 
	{
		return;	// Deprecated

		return (
			<section className="pdp-user-selection__unavailable">
				<div className="text-divider l-margin-bottom">
					<div className="text-divier__text l-pad-x">
						<strong>LEGO Shop</strong>
					</div>
				</div>
				<div className="l-flex l-split l-center l-margin-bottom">
					<div>
						<strong className="text--title">{blapp.format.formatMoney(399.99)}</strong>
					</div>
					<a href="//www.lego.com" className="btn btn--cta l-block text--bold">LEGO Shop<i className="l-margin-left--sm far fa-external-link-square-alt"/></a>
				</div>
				<div className="text-color--primaryRed">
					This item is not available on BrickLink. You can buy it from the LEGO online shop.
				</div>
			</section>
		);
	}

	renderNoInstantCheckout() 
	{
		let classicLink	= this.props.itemBasic ? blapp.url.getCatalogItemPageURL( this.props.itemBasic.idItem ) : ( "//" + blapp.config.getHost( "www" ) + "/v2/main.page" );

		return (
			<section className="pdp-user-selection__unavailable">
				<p className="l-margin-bottom" dangerouslySetInnerHTML={{__html: $T("ITEM_NOT_AVAILABLE_IC", [classicLink])}}/>
				<button className="btn btn--cta l-full-width text--bold" onClick={(e)=>this.props.func.doAddToWanted()}><i className="far fa-heart l-margin-right--sm"/>{$T("ADD_TO_LIST")}</button>
			</section>
		);
	}

	renderNoAvailable() 
	{
		return (
			<section className="pdp-user-selection__unavailable">
				<p className="l-margin-bottom">
					{$T("ITEM_NOT_AVAILABLE")}
				</p>
				<button className="btn btn--cta l-full-width text--bold" onClick={() => this.props.func.doAddToWanted()}><i className="far fa-heart l-margin-right--sm"/>{$T("ADD_TO_LIST")}</button>
			</section>
		);
	}

	renderEasyBuyAll() 
	{
		let	cond_str;

		switch ( this.props.selectedCond )
		{
		case "NS":	cond_str	= "new and sealed";		break;
		case "NC":	cond_str	= "new and complete";	break;
		case "UC":	cond_str	= "used but complete";	break;
		case "N":	cond_str	= "new";				break;
		case "U":	cond_str	= "used";				break;
		default:	cond_str	= this.props.typeItem == "S" ? "new and sealed" : "new";	break;
		}

		return (
			<section className="pdp-user-selection__unavailable">
				<p className="l-full-width l-margin-bottom">
					Buy all {cond_str} { this.props.typeItem == "S" ? "sets" : "items" } from multiple stores.
				</p>
				<button className="btn btn--cta-alt-outline l-full-width bg-color--white text--bold" onClick={()=>this.props.func.doEasyBuy()}><i className="fas fa-wand-magic-sparkles l-margin-right--sm"/>Easy buy</button>
			</section>
		);
	}

	renderEasyBuySome() 
	{
		let	cond_str;

		switch ( this.props.selectedCond )
		{
		case "NS":	cond_str	= $T("NEW_AND_SEALED");		break;
		case "NC":	cond_str	= $T("NEW_AND_COMPLETE");	break;
		case "UC":	cond_str	= $T("USED_BUT_COMPLETE");	break;
		case "N":	cond_str	= $T("NEW_1");				break;
		case "U":	cond_str	= $T("USED_1");				break;
		default:	cond_str	= this.props.typeItem == "S" ? $T("NEW_AND_SEALED") : $T("NEW_1");	break;
		}

		return (
			<section className="pdp-user-selection__unavailable">
				<p className="l-margin-bottom">
					{$T("BUY_MORE",[cond_str, this.props.typeItem == "S" ? "sets" : "items" ])}
				</p>
				<button className="btn btn--cta-alt-outline l-full-width bg-color--white text--bold" onClick={()=>this.props.func.doEasyBuy()}><i className="fas fa-wand-magic-sparkles l-margin-right--sm"/>{$T("EASY_BUY")}</button>
			</section>
		);
	}
};


SellerBox.propTypes = {
		typeItem:		PropTypes.string
	,	itemBasic:		PropTypes.object
	,	selectedQty:	PropTypes.number
	,	selectedCond:	PropTypes.string
	,	wantedQty:		PropTypes.number
	,	status:			PropTypes.number
	,	chosenInvData:	PropTypes.object
	,	maxBuyableQty:	PropTypes.number
	,	func:			PropTypes.shape( 
							{ 
								triggerZoomModal: 	PropTypes.func
							,	updateQty: 			PropTypes.func
							,	updateCond: 		PropTypes.func
							,	doAddToCart:		PropTypes.func
							,	doEasyBuy: 			PropTypes.func 
							,	doAddToWanted:		PropTypes.func 
							} 
						)
};

var $T = BLComponent.createTextMap(
	{
		"NEW":
		{
			"en":	"New"
		,	"es":	"Nuevo"
		}
	,	"USED":
		{
			"en":	"Used"
		,	"es":	"Usado"
		}
	,	"NEW_SEALED":
		{
			"en":	"New, sealed"
		,	"es":	"Nuevo, precintado"
		}
	,	"NEW_COMPLETE":
		{
			"en":	"New, complete"
		,	"es":	"Nuevo, completo"
		}
	,	"USED_COMPLETE":
		{
			"en":	"Used, complete"
		,	"es":	"Usado, completo"
		}
	,	"QUANTITY":
		{
			"en":	"Quantity"
		,	"es":	"Cantidad"
		}
	,	"MY_WANTED_QTY":
		{
			"en":	"My wanted qty:"
		,	"es":	"Cantidad deseada:"
		}
	,	"CONDITION":
		{
			"en":	"Condition"
		,	"es":	"Condición"
		}
	,	"ONLY_COMPLETE_SETS":
		{
			"en":	"Only complete sets are available"
		,	"es":	"Sólo están disponibles sets completos"
		}
	,	"ITEM_CONDITION":
		{
			"en":	"Item condition"
		,	"es":	"Condición del producto"
		}
	,	"LOADING":
		{
			"en":	"Loading..."
		,	"es":	"Cargando..."
		}
	,	"ERROR":
		{
			"en":	"Error!"
		,	"es":	"Error!"
		}
	,	"ADD_N_TO_CART":
		{
			"en":	"Add {{$0}} to cart"
		,	"es":	"Añadir {{$0}} a la cesta"
		}
	,	"NOTE_FROM_SELLER":
		{
			"en":	"Note from seller:"
		,	"es":	"Nota del vendedor:"
		}
	,	"ITEM_NOT_AVAILABLE":
		{
			"en":	"This item is not available. Add it to your Wanted List so that sellers can notify you when it's available."
		,	"es":	"Este producto no está disponible. Añádelo a tu lista de deseo para que los vendedores puedan notificarte cuando está disponible."
		}
	,	"ITEM_NOT_AVAILABLE_IC":
		{
			"en":	`This item is not available for purchase with Instant Checkout. Add it to your Wanted List or visit <a href="{{$0}}" target="_blank">BrickLink Classic</a> for an invoice-based transaction.`
		,	"es":	`Este producto no está disponible para comprar con Instant Checkout. Añádelo a tu lista de deseo o visita <a href="{{$0}}" target="_blank">BrickLink Classic</a> para una transacción con factura.`
		}
	,	"ADD_TO_LIST":
		{
			"en":	"Add to Wanted List"
		,	"es":	"Añadir a lista"
		}
	,	"BRICKLINK_CLASSIC":
		{
			"en":	"BrickLink Classic"
		,	"es":	"BrickLink Classic"
		}
	,	"NEW_AND_SEALED":
		{
			"en":	"new and sealed"
		,	"es":	"nuevo y precintado"
		}
	,	"NEW_AND_COMPLETE":
		{
			"en":	"new and complete"
		,	"es":	"nuevo y completo"
		}
	,	"USED_BUT_COMPLETE":
		{
			"en":	"used but complete"
		,	"es":	"usado pero completo"
		}
	,	"NEW_1":
		{
			"en":	"new"
		,	"es":	"nuevo"
		}
	,	"USED_1":
		{
			"en":	"used"
		,	"es":	"usado"
		}
	,	"OR":
		{
			"en":	"OR"
		,	"es":	"O"
		}
	,	"BUY_MORE":
		{
			"en":	"Buy more {{$0}} {{$1}} from multiple stores."
		,	"es":	"Compra más {{$1}} {{$0}} de varias tiendas."
		}
	,	"EASY_BUY":
		{
			"en":	"Easy buy"
		,	"es":	"Easy buy"
		}
	,	"STORE_TERMS":
		{
			"en":	"Store terms and policies"
		,	"kr":	""
		,	"es":	""
		}
	}
);
